import config from "./index";

async function fetchPartners() {
  const response = await fetch(`${config.apiUrl}/v1/partners`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authentication-Token": config.getToken(),
    },
  });
  const data = await response.json();
  return data;
}

async function fetchSpotlightPartner() {
  const response = await fetch(`${config.apiUrl}/v1/partners/spotlight`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "Authentication-Token": config.getToken(),
    },
  });
  const data = await response.json();
  return data;
}

async function createPartner(formData) {
  const response = await fetch(`${config.apiUrl}/v1/partners`, {
    method: "POST",
    headers: {
      "Authentication-Token": config.getToken(),
    },
    body: formData,
  });
  const data = await response.json();
  return data;
}

async function updatePartner(formData) {
  const response = await fetch(`${config.apiUrl}/v1/partners`, {
    method: "PUT",
    headers: {
      "Authentication-Token": config.getToken(),
    },
    body: formData,
  });
  const data = await response.json();
  return data;
}

async function deletePartner(partnerId) {
  const response = await fetch(`${config.apiUrl}/v1/partners`, {
    method: "DELETE",
    headers: {
      "Content-Type": "application/json",
      "Authentication-Token": config.getToken(),
    },
    body: JSON.stringify({ partner_id: partnerId }),
  });
  const data = await response.json();
  return data;
}

export default {
  fetchPartners,
  fetchSpotlightPartner,
  createPartner,
  updatePartner,
  deletePartner,
};
